//FireBase
exports.firebaseConfig = {
    apiKey: "AIzaSyAqydsGyw7uKKV8_2Rn9p_KsLqYiZvusM4",
    authDomain: "rangers-4e918.firebaseapp.com",
    databaseURL: "https://rangers-4e918.firebaseio.com",
    projectId: "rangers-4e918",
    storageBucket: "rangers-4e918.appspot.com",
    messagingSenderId: "330352138714"
  };



//App setup
exports.adminConfig={
  "appName": "Rangers Admin",
  "slogan":"",
  "design":{
    "sidebarBg":"sidebar-1.jpg", //sidebar-1, sidebar-2, sidebar-3
    "dataActiveColor":"red", //"purple | blue | green | orange | red | rose"
    "dataBackgroundColor":"black", // "white | black"
  },
  "googleMapsAPIKey":"AIzaSyBb2KuSUfCsoEqOYuN7Ddtk4PkhsN4eo4g",
  "showItemIDs":false,
  "allowedUsers":null, //If null, allow all users, else it should be array of allowd users
  "allowGoogleAuth":true, //Allowed users must contain list of allowed users in order to use google auth
  "fieldBoxName": "Fields",
  "maxNumberOfTableHeaders":5,
  "prefixForJoin":["order","user","driver","agent","topup"],
  "showSearchInTables":true,
  "methodOfInsertingNewObjects":"timestamp", //timestamp (key+time) | push - use firebase keys
  "urlSeparator":"+",
  "urlSeparatorFirestoreSubArray":"~",

  "fieldsTypes":{
    "photo":["photo","image","imageProof"],
    "dateTime":["end","orderCreatedDate","orderDriverAcceptedDate","orderCancelledDate","orderCompletedDate","topupDate"],
    "map":["map","latlng"],
    "textarea":["description","notes"],
    "html":["content"],
    "radio":["radio","radiotf","featured","type"],
    "checkbox":["checkbox","service"],
    "dropdowns":["status","dropdowns","serviceType","method","clients"],
    "file":["video"],
    "rgbaColor":['rgba'],
    "hexColor":['color'],
    "relation":['creator','driver','user','agent','topup'],
    "iconmd":['icon'],
    "iconfa":['iconfa'],
    "iconti":['iconti'],
  },
  "optionsForDateTime":[
    {"key":"end", "dateFormat":"YYYY-MM-DD" ,"timeFormat":true, "saveAs":"x","locale":"es"},
    {"key":"orderCreatedDate", "dateFormat":"DD-MM-YYYY" ,"timeFormat":"HH:mm A", "saveAs":"DD/MM/YYYY HH:mm A"},
    {"key":"orderDriverAcceptedDate", "dateFormat":"DD-MM-YYYY" ,"timeFormat":"HH:mm A", "saveAs":"DD/MM/YYYY HH:mm A"},
    {"key":"orderCancelledDate", "dateFormat":"DD-MM-YYYY" ,"timeFormat":"HH:mm A", "saveAs":"DD/MM/YYYY HH:mm A"},
    {"key":"orderCompletedDate", "dateFormat":"DD-MM-YYYY" ,"timeFormat":"HH:mm A", "saveAs":"DD/MM/YYYY HH:mm A"},
    {"key":"topupDate", "dateFormat":"DD-MM-YYYY" ,"timeFormat":"HH:mm A", "saveAs":"DD/MM/YYYY HH:mm A"}
  ],
  "optionsForSelect":[
      {"key":"dropdowns","options":["new","processing","rejected","completed"]},
      {"key":"checkbox","options":["Skopje","Belgrade","New York"]},
      {"key":"service","options":["Jumpstart Battery","New Battery","Spare Tyre Change","Patch Tyre","Send Petrol","On Site: 4x4","On Site: Tow Truck"]},
      {"key":"serviceType","options":["Jumpstart Battery","New Battery","Spare Tyre Change","Patch Tyre","Send Petrol","On Site: 4x4","On Site: Tow Truck"]},
      {"key":"status","options":["New","Ready","Accepted","Cancelled","Completed"]},
      {"key":"radio","options":["no","maybe","yes"]},
      {"key":"radiotf","options":["true","false"]},
      {"key":"featured","options":["true","false"]},
      {"key":"type","options":["Web","iOS","Android"]},
      {"key":"method","options":["Cash","Bank Transfer"]},
      {"key":"clients","options":["Public","Etiqa","Nissan","Medivest","Radicare","MYEG","JPJ","Perodua","PLUS","Blancheur","AZRB","SPANCO"]}
  ],
  "optionsForRelation":[
      {
        //Firebase - Mimic function
        "display":"username",
        "key":"user",
        "path":"/users",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":false,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      },
      {
        //Firebase - Mimic function
        "display":"drivername",
        "key":"driver",
        "path":"/drivers",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":false,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      },
      {
        //Firebase - Mimic function
        "display":"agentname",
        "key":"agent",
        "path":"/agents",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":false,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      },
      {
        //Firebase - Mimic function
        "display":"amount",
        "key":"topup",
        "path":"/topups",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":false,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      },
      {
        //Firestore - Native
        "display": "name",
        "isValuePath": true,
        "key": "creator",
        "path": "/users",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "name"
      },
      {
        //Firebase - Mimic function
        "display":"name",
        "key":"eventtype",
        "path":"",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":true,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      }
  ],
  "paging":{
    "pageSize": 50,
    "finite": true,
    "retainLastPage": false
  }
}

//Navigation
exports.navigation=[
    // {
    //   "link": "/",
    //   "name": "Dashboard",
    //   "schema":null,
    //   "icon":"home",
    //   "path": "",
    //    isIndex:true,
    // },
    // {
    //   "link": "fireadmin",
    //   "path": "users",
    //   isIndex:true,
    //   "name": "Users",
    //   "icon":"people",
    //   "tableFields":["username","phone","email"],
    // },
    {
      "link": "fireadmin",
      "path": "orders",
      isIndex:true,
      "name": "Orders",
      "icon":"build",
      "tableFields":["orderNo","status","orderCreatedDate","customerName","driver","serviceType"],
    },
    {
      "link": "fireadmin",
      "path": "drivers",
      "name": "Drivers",
      "icon":"local_shipping",
      "tableFields":["drivername","phone","email","service","location","credit"],
    },
    {
      "link": "fireadmin",
      "path": "topups",
      "name": "Topups",
      "icon":"monetization_on",
      "tableFields":["topupDate","driver","amount","method"],
    }
    // {
    //   "link": "fireadmin",
    //   "path": "agents",
    //   "name": "Agents",
    //   "icon":"contact_phone",
    //   "tableFields":["agentname","phone","email"],
    // }
    // {
    //   "link": "fireadmin",
    //   "path": "bookings",
    //   isIndex:true,
    //   "name": "Bookings",
    //   "icon":"build",
    //   "tableFields":["name","place"],
    // }
    // {
    //   "link": "fireadmin",
    //   "path": "events",
    //   "name": "Events",
    //   "icon":"event",
    //   "tableFields":["name","description"],
    //   "subMenus":[
    //     {
    //       "link": "fireadmin",
    //       "path": "events/skopje/items",
    //       "name": "Skopje",
    //       "icon":"event",
    //       "tableFields":["name","description"]
    //     },{
    //       "link": "fireadmin",
    //       "path": "events/sofia/items",
    //       "name": "Sofia",
    //       "icon":"event",
    //       "tableFields":["name","description"],
    //     },{
    //       "link": "fireadmin",
    //       "path": "events/belgrade/items",
    //       "name": "Belgrade",
    //       "icon":"event",
    //       "tableFields":["name","description"],
    //     }
    //   ]
    // },
    // {
    //   "link": "fireadmin",
    //   "path": "clubs",
    //   "name": "Clubs",
    //   "icon":"room",
    //   "tableFields":["name","description"],
    //   "subMenus":[
    //     {
    //       "link": "fireadmin",
    //       "path": "clubs/skopje/items",
    //       "name": "Skopje",
    //       "icon":"event",
    //       "tableFields":["name","description"]
    //     },{
    //       "link": "fireadmin",
    //       "path": "clubs/sofia/items",
    //       "name": "Sofia",
    //       "icon":"event",
    //       "tableFields":["name","description"],
    //     },{
    //       "link": "fireadmin",
    //       "path": "clubs/belgrade/items",
    //       "name": "Belgrade",
    //       "icon":"event",
    //       "tableFields":["name","description"],
    //     }
    //   ]
    // },
    // {
    //   "link": "fireadmin",
    //   "path": "bookings",
    //   "name": "Bookings",
    //   "icon":"done",
    //   "tableFields":[],
    // },{
    //   "link": "fireadmin",
    //   "path": "static",
    //   "name": "Cities & Genres",
    //   "icon":"location_city",
    //   "tableFields":["name","description"],
    // },{
    //   "link": "firestoreadmin",
    //   "path": "events",
    //   "name": "FireStore Events",
    //   "icon":"event",
    //   "tableFields":["name"],
    // },
    // {
    //   "link": "push",
    //   "path": "",
    //   "name": "Push notification",
    //   "icon":"speaker_notes",
    //   "tableFields":[],
    // }
  ];

exports.pushSettings={
  "pushType":"firebase", //firebase or onesignal
  "Firebase_AuthorizationPushKey":"AIzaSyCFUf7fspu61J9YsWE-2A-vI9of1ihtSiE", //Firebase push authorization ket
  "pushTopic":"news", //Only for firebase push
  "oneSignal_REST_API_KEY":"",
  "oneSignal_APP_KEY":"",
  "included_segments":"Active Users", //Only for onesignal push
}

exports.userDetails={

}

exports.remoteSetup=false;
exports.remotePath="testadmina";
exports.allowSubDomainControl=true;
exports.subDomainControlHolder="admins/";



// WEBPACK FOOTER //
// ./src/config/app.js